import { Box, Link, Typography } from '@mui/material';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { Svgs } from '../assets/svg';

const appendToBody = () => document.body;

type PopupPlacement = 'top' | 'right' | 'bottom' | 'left';

interface PricebookInfoPopupProps {
  body?: string;
  title?: string;
  onLearnMore?: () => void;
  iconSize?: number;
  iconVariant?: 'default' | 'custom';
  placement?: PopupPlacement;
  ariaLabel?: string;
  passClickThrough?: boolean;
}

const PricebookInfoPopup: React.FC<PricebookInfoPopupProps> = ({
  body,
  title,
  onLearnMore,
  iconSize = 18,
  iconVariant = 'default',
  placement = 'top',
  ariaLabel = 'More information',
  passClickThrough = false,
}) => {
  const InfoIcon = iconVariant === 'custom' ? Svgs.IconInfoCustom : Svgs.IconInfoDefault;

  return (
    <Tippy
      content={
        <Box sx={{ maxWidth: '400px' }} onClick={e => e.stopPropagation()}>
          {title && (
            <Typography component='div' variant='p18Bold' color='secondary.dark' mb='8px'>
              {title}
            </Typography>
          )}
          <Typography variant='p16Light' color='secondary.dark' component='span'>
            {body}
            {onLearnMore && (
              <Link
                component='button'
                type='button'
                variant='p16Light'
                color='primary.main'
                sx={{
                  textDecoration: 'underline',
                  verticalAlign: 'baseline',
                  ml: body ? '4px' : 0,
                }}
                onClick={e => {
                  e.stopPropagation();
                  onLearnMore();
                }}>
                Learn more
              </Link>
            )}
          </Typography>
        </Box>
      }
      placement={placement}
      interactive
      hideOnClick={false}
      trigger='mouseenter focus'
      appendTo={appendToBody}
      theme='tippy-rounded'
      arrow>
      <Box
        role='button'
        tabIndex={0}
        aria-label={ariaLabel}
        display='flex'
        sx={{
          'cursor': 'default',
          '&:focus-visible': {
            outline: '2px solid',
            outlineColor: 'primary.main',
            borderRadius: '4px',
          },
        }}
        onClick={passClickThrough ? undefined : e => e.stopPropagation()}>
        <InfoIcon style={{ width: `${iconSize}px`, height: `${iconSize}px` }} />
      </Box>
    </Tippy>
  );
};

export default PricebookInfoPopup;
